// @ts-check
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();
const { GF_DOTCOM_YOTPO_APP_KEY } = publicRuntimeConfig;

const yotpoWidgetScriptSrc = `https://staticw2.yotpo.com/${GF_DOTCOM_YOTPO_APP_KEY}/widget.js`;

/**
 * Safely call `refreshWidgets` in yotpo API
 */
const refreshWidgets = () => {
  if (typeof window !== 'undefined' && window.yotpo) {
    try {
      if (window.yotpo.getState() === 'ready') {
        window.yotpo.refreshWidgets();
      }
    } catch (e) {
      console.warn('Error refreshing yotpo widget:');
      console.error(e);
    }
  }
};

/**
 * @typedef {object} Props
 * @property {string} productId
 * @property {React.ReactNode} children
 */

/**
 * Add the Yotpo widget script to the page and refresh any widgets
 * @param {Props} props
 */
const YotpoWidgetContainer = ({ productId, children }) => {
  // Refresh widgets when product ID changes
  useEffect(() => {
    refreshWidgets();
  }, [productId]);

  return (
    <>
      <Helmet>
        <script src={yotpoWidgetScriptSrc} />
      </Helmet>
      {children}
    </>
  );
};

YotpoWidgetContainer.propTypes = {
  productId: PropTypes.string,
  children: PropTypes.node.isRequired,
};

YotpoWidgetContainer.defaultProps = {
  productId: null,
};

export default YotpoWidgetContainer;
